import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistor, store, sagaMiddleware } from './js/store/store';
import SplashScreen from './js/components/SplashScreen';
import App from './js/containers/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import sagas from './js/store/sagas';

import 'onsenui/css/onsenui.css';
import '@hockeydata/numeric-input/dist/index.css';
import './css/index.scss';

sagaMiddleware.run( sagas );

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={<SplashScreen />} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>,
    document.getElementById( 'app-root' )
);

const serviceWorkerConfiguration = {

    onUpdate: registration => {

        // console.log( 'serviceWorkerConfiguration.onUpdate.registration', registration );

        if ( registration && registration.waiting ) {

            window.appUpdateAvailable = true;

        }

    },

    onSuccess: registration => {

        // console.log( 'serviceWorkerConfiguration.onSuccess.registration', registration );

    }

};

serviceWorkerRegistration.register( serviceWorkerConfiguration );